import { createModule } from '../../createModule';
export const createFlowsAPI = createModule(({ http, streaming }) => {
    const streamReport = (params) => streaming.stream({
        path: '/v2/flows/report/stream',
        ...params,
    });
    // ---
    return {
        getFunds: async () => {
            const res = await http.get('/v2/flows/funds');
            return res;
        },
        getSummary: async () => {
            const res = await http.get('/v2/flows/summary');
            return res;
        },
        getHistory: async () => {
            const res = await http.get('/v2/flows/history');
            return res;
        },
        runReport: async (params) => {
            const res = await http.get('/v2/flows/report', {
                params,
            });
            return res;
        },
        streamReport,
    };
});
